import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import {Card, CardActions, CardMedia, Button, Tooltip} from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'left',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.5),
    margin: 0
  },
  chip: {
    margin: theme.spacing(0.5)
  },
  card: {
    width: 170,
    height: 240,
    margin: 'auto'
  },
  cardMedia:{
    width: 160,
    height: 180,
    margin: 'auto'
  },
  cardActions:{
    marginTop: theme.spacing(2),
    height: 30
  }
}));


const SingleAttachement = (props) => {
const {
 data,
 handleDelete,
 fileName
  } = props;
  const classes = useStyles();

  const [imageUrl, setImageUrl] = React.useState("");

  useEffect(() => {
    if (data.fileData == null) {
      setImageUrl(data.url)
        return
    }

    const objectUrl = URL.createObjectURL(data.fileData)
    setImageUrl(objectUrl)

    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl)
}, [data])


  return (
    <Card className={classes.card}   >
    <CardMedia
      component="img"
      alt={fileName}
      height="140"
      image={imageUrl}
      className={classes.cardMedia}
    >
      </CardMedia>

    <CardActions   className={classes.cardActions}>
    <Tooltip title= {fileName}>
        {data.fileData == null ?  <Button size="small" onClick={() => window.open(data.url)} >Download</Button> :  <Button size="small"  disabled >Download</Button>}
  
  </Tooltip>
      <Button size="small" onClick={handleDelete(data)} >Delete</Button>
    </CardActions>
  </Card>
  );
}


const CardAttachments = (props) => {
  const classes = useStyles();
  const { allAttachments, onRemoveAttachment } = props;

  const handleDelete = (attachmentToDelete) => () => {
    onRemoveAttachment(attachmentToDelete);
  };

  if (!allAttachments) return;

  const checkedName = (data) => {
    return data.fileData === null ? data.name : data.fileData.name;
  };

  return (
    <Paper component="ul" className={classes.root}>
      {allAttachments.map((data, index) => {
        return (
          <li key={index}>
               < SingleAttachement data = {data} handleDelete = {handleDelete} fileName = {checkedName(data)}> </SingleAttachement>
          </li>
        );
      })}
    </Paper>
  );
};

export default CardAttachments;

